import { Typography, List, ListItem, ListItemText } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import HeaderTitle from '../Header/HeaderTitle'
import { Helmet } from 'react-helmet'
import { string } from 'prop-types'

const styles = makeStyles((theme) => ({
  centerList: {
    margin: 'auto',
    padding: '5px',
  },
  centerDiv: {
    margin: 'auto',
    width: '60%',
  },
  myBox: {
    width: '100%',
    margin: '0px',
    padding: '0px',
  },
}))

const LandingPage = (props) => {
  const classes = styles(props)
  const { headerTitle } = props

  return (
    <div className={classes.myBox}>
      <HeaderTitle title="T.O.M. - Target Outreach Manager - Home" />
      <Helmet>
        <title>{headerTitle}</title>
      </Helmet>
      <div className={classes.centerDiv}>
        <Typography variant="h4">
          Welcome to Target Outreach Manager!
        </Typography>
        <Typography component="span" variant="subtitle2">
          T.O.M. is used to contact Target team members automatically, and can
          be utilized to report based on the response of the contact attempt.
        </Typography>
        <br />
        <Typography component="span">
          To start using this tool, you have to log in by clicking on the upper
          left corner, and sign in with your LAN credentials. You have to have
          the proper access in order to use different functions. You can request
          access through{' '}
          <a href="https://myaccess.target.com/auth/login">MyAccess</a>
          <br />
        </Typography>
        <br />
        <Typography component="span" variant="h6">
          Business Continuity Planning (BCP)
        </Typography>
        <List dense className={classes.centerList}>
          <ListItem>
            <ListItemText
              primary="APP-OAUTH2-TOM-BCP"
              secondary="For BCP Notification Messaging"
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="APP-OAUTH2-TOM-BCP-Reporting"
              secondary="For BCP Reporting Access"
            />
          </ListItem>
        </List>
        <br />
        <Typography component="span" variant="h6">
          C3
        </Typography>
        <List dense className={classes.centerList}>
          <ListItem>
            <ListItemText
              primary="APP-OAUTH2-TOM-C3"
              secondary="For C3 Crisis Messaging"
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="APP-OAUTH2-TOM-C3-Reporting"
              secondary="For C3 Reporting Access"
            />
          </ListItem>
        </List>
        <br />
        <Typography component="span" variant="h6">
          C3A
        </Typography>
        <List dense className={classes.centerList}>
          <ListItem>
            <ListItemText
              primary="APP-OAUTH2-TOM-C3A"
              secondary="For C3A Crisis Messaging"
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="APP-OAUTH2-TOM-C3A-Reporting"
              secondary="For C3A Reporting Access"
            />
          </ListItem>
        </List>
        <br />
        <Typography component="span" variant="h6">
          Capella
        </Typography>
        <List dense className={classes.centerList}>
          <ListItem>
            <ListItemText
              primary="APP-OAUTH2-TOM-Capella"
              secondary="For Capella API Access"
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="APP-OAUTH2-TOM-Capella-Reporting"
              secondary="For Capella API Access to Reporting"
            />
          </ListItem>
        </List>
        <br />
        <Typography component="span" variant="h6">
          Critical Event Emergency (CEE) Backup Process
        </Typography>
        <List dense className={classes.centerList}>
          <ListItem>
            <ListItemText
              primary="APP-OAUTH2-TOM-CEEBackup"
              secondary="For CEE Backup Messaging"
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="APP-OAUTH2-TOM-CEEBackup-Reporting"
              secondary="For CEE Backup Reporting Access"
            />
          </ListItem>
        </List>
        <br />
        <Typography component="span" variant="h6">
          FMOC DC
        </Typography>
        <List dense className={classes.centerList}>
          <ListItem>
            <ListItemText
              primary="APP-OAUTH2-TOM-FMOCDC"
              secondary="For FMOC DC Crisis Messaging"
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="APP-OAUTH2-TOM-FMOCDC-Reporting"
              secondary="For FMOC DC Reporting Access"
            />
          </ListItem>
        </List>
        <br />
        <Typography component="span" variant="h6">
          Product Recall
        </Typography>
        <List dense className={classes.centerList}>
          <ListItem>
            <ListItemText
              primary="APP-OAUTH2-TOM-Recall"
              secondary="For Product Recall Messaging"
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="APP-OAUTH2-TOM-Recall-Reporting"
              secondary="For Product Recall Reporting Access"
            />
          </ListItem>
        </List>
        <br />
        <Typography component="span" variant="h6">
          Stores HR
        </Typography>
        <List dense className={classes.centerList}>
          <ListItem>
            <ListItemText
              primary="APP-OAUTH2-TOM-StoreHR"
              secondary="For Stores HR Crisis Messaging"
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="APP-OAUTH2-TOM-StoreHR-Reporting"
              secondary="For Stores HR Reporting Access"
            />
          </ListItem>
        </List>
        <Typography component="span" variant="h6">
          Developers
        </Typography>
        <List dense className={classes.centerList}>
          <ListItem>
            <ListItemText
              primary="APP-OAUTH2-NS-VSAPIDeveloper-NP"
              secondary="For Developers Only, Non Prod"
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="APP-OAUTH2-NS-VSAPIDeveloper-PRD"
              secondary="For Developers Only, Prod"
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="APP-OAUTH2-TOM-Developer"
              secondary="For Developers Only"
            />
          </ListItem>
        </List>
        <br />
      </div>
    </div>
  )
}

export default LandingPage

LandingPage.propTypes = {
  headerTitle: string,
}
